export { default } from "./StudentAssignmentInstructions";
